import { Page } from "modules/Page";
import { initAnchorNavigation } from "modules/AnchorNavigation";

export class HomePageRevamp extends Page<typeof HomePageRevamp> {
    public static readonly className = "js-home-page-revamp-page";

    constructor(rootElement: HTMLElement, index: number) {
        super(rootElement, index);

        initAnchorNavigation(".js-home-page-revamp-page");
    }
}